import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './Kicker.module.scss';

type Props = {
  label: string;
  iconType?: string;
};

const baseClass = 'gdb-kicker';

export const Kicker = ({ label, iconType }: Props) => {
  return (
    <div className={styles[`${baseClass}-wrapper`]}>
      {iconType && <Icon type={iconType} className={styles[`${baseClass}-icon`]} />}

      <div className={styles[`${baseClass}-label`]}>{label}</div>
    </div>
  );
};
